import Environment from '../common/Environment';
import Member from '../entities/Member';
import MemberJson from '../jsons/MemberJson';

export default class PostMember {
  execute(member: Member, account: Member): Promise<Member> {
    const method: string = 'POST';
    const path = Environment.server() + '/member';

    return new Promise((resolve, reject) => {
      fetch(path, {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          account,
          member
        })
      })
        .then((response: Response) => {
          if (response.ok) {
            return response.json();
          } else {
            reject(response.status);
            return null;
          }
        })
        .then((responseJson: MemberJson) => {
          if (
            responseJson.api === undefined ||
            responseJson.api.status === undefined
          ) {
            reject('Server Error');
          } else if (responseJson.api.status === 'success') {
            resolve(responseJson.member);
          } else {
            reject(responseJson.api.errorMessage);
          }
        })
        .catch(error => {
          console.log(error.message);
          reject(
            `通信に失敗しました。ネットワークに問題がある可能性があります。\n${error.message}`
          );
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/apis/PostMember.ts